<template>
  <div class="pay">
    <!-- <div class="left flexc">
      <div class="flexa item">
        <span>付款方式：</span>
        <span>新卡支付</span>
      </div>
      <div class="flexa item">
        <span>收款方式：</span>
        <span>1234567890123456 - 全球付卡</span>
      </div>
      <div class="flexa item">
        <span>收款人：</span>
        <span>張三</span>
      </div>
      <div class="flexa item">
        <span>轉賬金額：</span>
        <span>100 CNY</span>
      </div>
      <div class="flexa item">
        <span>手續費：</span>
        <span>5 CNY</span>
        <span>明細</span>
      </div>
      <div class="flexa item">
        <span>合計支付：</span>
        <span>100</span>
        <span>CNY</span>
      </div>
    </div>-->
    <div class="right flexc flexa">
      <div class="tips" v-if="isValid">
        二維碼還有（
        <span class="p-FA800A">{{count}}</span>）秒過期，請盡快支付
      </div>
      <div style="margin-left: -40px;" v-else>二維碼已過期，請重新獲取！</div>
      <img src="@/assets/fps-img.png" alt />
      <div class="tips-bottom">
        <span class="paid" @click="queryPayResult">我已完成支付</span>
        <span class="link" @click="back">{{str}}</span>
      </div>
      <div id="qrcode" v-if="isValid" class="qr_code" ref="qrcode"></div>
      <div class="text flexaj" @click="order">刷新</div>
      <!-- <img src="@/assets/qr_code.png" alt /> -->
    </div>
  </div>
</template>

<script>
import { aPost2 } from "@/utils/request";
import api from "@/utils/api";
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      isCounting: false,
      isValid: true,
      clock: null,
      count: 60,
      payDetail: {},
      payParams: {},
      str: "<<選擇其他方式支付",
      index: 0
    };
  },
  methods: {
    //查詢支付狀態
    async queryPayResult() {
      let params = {
        mer_order_no: this.payDetail.mer_order_no
      };
      let res = await aPost2(api.queryPayResult, params);
      if (res.data.errCode === "99999") {
        if (
          res.data.retData.order_result.order_status === "SUCC" ||
          res.data.retData.order_result.order_status === "FINISH"
        ) {
          this.$router.push({
            name: "success",
            params: { order_no: this.payParams.order_no }
          });
        } else {
          this.$message({
            message: "支付未完成！",
            type: "error"
          });
        }
      }
    },
    //  生成二維碼
    qrcode() {
      let that = this;
      let qrcode = new QRCode(`qrcode`, {
        width: 132,
        height: 132, // 高度
        text: that.payDetail.pay_info
        // text: that.payDetail.pa_info
      });
    },
    //倒計時
    startCounting() {
      this.$nextTick(function() {
        this.qrcode();
      });
      this.count = 60;
      let that = this;
      that.isCounting = true;
      that.clock = setInterval(() => {
        if (that.count > 0) {
          that.count--;
        } else {
          that.isValid = false;
          that.index++;
          clearInterval(that.clock);
          that.clock = null;
          that.isCounting = false;
        }
      }, 1000);
    },
    back() {
      this.$router.go(-1);
    },
    async order() {
      let params = this.payParams;
      if (this.payParams.order_no) {
        let res = await aPost2(api.moneyIn, params);
        if (res.data.errCode === "99999") {
          this.payDetail = res.data.retData;
          this.isValid = true;
          this.startCounting();
        }
      } else {
        this.$message({
          message: "訂單號丟失，請重新打開郵件鏈接！",
          type: "success"
        });
      }
    }
  },
  mounted() {
    if (this.$route.params.payDetail) {
      this.startCounting();
      this.payDetail = this.$route.params.payDetail;
      this.payParams = this.$route.params.payParams;
    } else if (this.$route.params.payParams) {
      this.order();
      // this.$message("支付")
    } else {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
.pay {
  display: flex;
  justify-content: center;
  width: 960px;
  margin: 40px auto;
  font-size: 16px;
  .UMPay {
    height: 100%;
  }
  .left {
    font-size: 16px;
    padding-top: 16px;
    .item {
      margin-bottom: 32px;
    }
  }
  .right {
    position: relative;
    .tips {
      /* padding-left: 32px; */
      padding-bottom: 10px;
    }
    .qr_code {
      position: absolute;
      left: 52px;
      top: 62px;
      z-index: 100;
    }
    .text {
      position: absolute;
      left: 86px;
      top: 100px;
      z-index: 1;
      color: #999;
      border: 1px solid #999;
      border-radius: 4px;
      padding: 4px 10px;
      cursor: pointer;
    }
    .paid {
      padding: 5px 12px;
      border: 1px solid #ccc;
      border-radius: 2px;
      cursor: pointer;
    }
    .tips-bottom {
      font-size: 14px;
      padding-top: 16px;
      /* padding-left: 100px; */
    }
    .link {
      padding-left: 32px;
    }
  }
}
</style>